import React from "react";
import { Input, Label } from "../../style_config/UseStyle";

export default function FilterCat({ data, oneSelect, isChecked }) {
  // 1. Extraction des catégories uniques et filtrage des valeurs nulles
  const uniqueCategories = [...new Set(data
    .map(item => item.categories)
    .filter(Boolean) // Retire les valeurs falsy (undefined, null, '')
  )];

  // 2. Gestion du clic plus accessible
  const handleClick = (e) => {
    e.stopPropagation();
    oneSelect(e);
  };

  return (
    <>
      {uniqueCategories.map((category, index) => (
        <Label
          key={`${category}-${index}`} // 3. Clé plus unique
          htmlFor={`filter-radio-${index}`}
          ml={0}
          fw={1}
          grid="true"
          data-value={category}
          onClick={handleClick}
          aria-checked={isChecked(category)} // 4. Accessibilité ARIA
          role="radio" // 4. Accessibilité
          tabIndex={0} // 4. Accessibilité clavier
        >
          <Input
            type="radio"
            id={`filter-radio-${index}`}
            name="filter"
            data-value={category}
            onChange={handleClick} // 5. Meilleure sémantique que onClick pour radio
            checked={isChecked(category)}
            readOnly
            aria-hidden="true" // 6. Masqué pour les lecteurs d'écran (géré par le Label)
          />
          <div aria-hidden="true"></div> {/* 7. Élément décoratif masqué */}
          {category}
        </Label>
      ))}
    </>
  );
}